/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-06-16 15:37:10
 */

import request from '@/utils/request'
export const queryPage = '/icps/system/sign/supplierSystem/car/QueryPage'//分页获取车辆信息
export const batchUpdateOrDelete = '/icps/system/sign/supplierSystem/car/deletes'
export const updateSortNum = ''
export const saveOrUpdate = '/icps/system/sign/supplierSystem/car/saveOrUpdate'
export const Download = '/icps/system/sign/supplierSystem/car/exportList'
export function initDataSource(data) {
  return request({
    url: '/icps/system/sign/basics/car/QueryPage',
    method: 'post',
    data
  })
}

export function editDataSource(data) {
  return request({
    url: '/icps/system/sign/basics/car/saveOrUpdate',
    method: 'post',
    data
  })
}